import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import AppointmentMain from './AppointmentMain';
import Footer from '../../components/Footer';

const Appointment = () => {
  return (
    <>
      <HeaderSeven />

      <AppointmentMain />

      <Footer />
    </>
  );
};

export default Appointment;
